import { atom, getDefaultStore } from 'jotai';
import { createApiClient } from '../api/client';

// See ./folders-atoms.md for the design rationale behind this file.

// { [region]: { folders: [], loading: false, fetched: false } }
export const foldersByRegionState = atom({});

// region -> in-flight Promise, deduped at module scope (see folders-atoms.md).
const inFlightFetchesByRegion = new Map();

export const fetchFoldersForRegion = region => {
  if (inFlightFetchesByRegion.has(region)) return inFlightFetchesByRegion.get(region);
  const promise = createApiClient(region)
    .get('/folder')
    .then(resp => resp?.data?.response?.folders ?? [])
    .finally(() => inFlightFetchesByRegion.delete(region));
  inFlightFetchesByRegion.set(region, promise);
  return promise;
};

// Generic cache-mutation primitive, callable from outside React (see folders-atoms.md).
export const setFoldersForRegion = (region, updater) => {
  if (!region) return;
  getDefaultStore().set(foldersByRegionState, prev => {
    // Falls back to an empty bucket rather than bailing on a missing entry (folders-atoms.md).
    const entry = prev[region] || { folders: [], loading: false, fetched: false };
    return { ...prev, [region]: { ...entry, folders: updater(entry.folders) } };
  });
};
